"use client";

import React from "react";

import { Card, CardContent } from "./ui/card";
import { SecuredFooter } from "./ui/secured-footer";
import logo from "../assets/images/80eight/88-footer-white.svg";
import bgVideo from "../assets/images/loader.mp4";

const PaymentLoader = () => {
  return (
    <Card className="w-full bg-white rounded-2xl border border-[#EBE9EF] !shadow-none relative overflow-hidden">
      <CardContent className="px-6 py-12 w-full">
        <div className="flex min-h-[400px] items-center justify-center relative">
          <div className="relative w-full max-w-[500px] aspect-[45/32]">
            <video
              src={bgVideo}
              autoPlay
              loop
              muted
              playsInline
              className="h-full w-full object-contain"
            />

            <img
              src={logo}
              alt="80eight"
              className="absolute inset-0 z-10 m-auto h-auto w-[160px]"
            />
          </div>
        </div>
      </CardContent>

      <SecuredFooter />
    </Card>
  );
};

export default PaymentLoader;
